// client/src/hooks/useSinais.js
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';
import useAlert from './useAlert';

const SINAIS_QUERY_KEY = 'sinais';

export const useSinais = (params = {}) => {
    return useQuery({
        queryKey: [SINAIS_QUERY_KEY, params],
        queryFn: () => api.get('/sinais', { params }).then(r => r.data),
        staleTime: 60 * 1000,
    });
};

export const useMutateSinais = () => {
    const queryClient = useQueryClient();
    const { setAlert } = useAlert();

    const invalidate = () => queryClient.invalidateQueries({ queryKey: [SINAIS_QUERY_KEY] });

    const createSinal = useMutation({
        mutationFn: (data) => api.post('/sinais', data),
        onSuccess: () => {
            invalidate();
            setAlert('Regra de sinal criada com sucesso!', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || err.response?.data?.message || 'Erro ao criar regra de sinal.', 'error'),
    });

    const updateSinal = useMutation({
        mutationFn: ({ id, data }) => api.put(`/sinais/${id}`, data),
        onSuccess: () => {
            invalidate();
            setAlert('Regra de sinal atualizada com sucesso!', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || err.response?.data?.message || 'Erro ao atualizar regra de sinal.', 'error'),
    });

    const deleteSinal = useMutation({
        mutationFn: (id) => api.delete(`/sinais/${id}`),
        onSuccess: () => {
            invalidate();
            setAlert('Regra de sinal removida com sucesso!', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || err.response?.data?.message || 'Erro ao remover regra de sinal.', 'error'),
    });

    const toggleAtivoSinal = useMutation({
        mutationFn: (id) => api.patch(`/sinais/${id}/alternar-status`),
        onSuccess: () => {
            invalidate();
            setAlert('Status da regra de sinal atualizado!', 'success');
        },
        onError: (err) => setAlert(err.response?.data?.error || err.response?.data?.message || 'Erro ao alternar status.', 'error'),
    });

    const isPending = createSinal.isPending || updateSinal.isPending || deleteSinal.isPending || toggleAtivoSinal.isPending;

    return { createSinal, updateSinal, deleteSinal, toggleAtivoSinal, isPending };
};

export default useSinais;
